import React from 'react';

import { Control, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { FieldErrors } from 'react-hook-form/dist/types/errors';

import { cardsDataQueryKey } from 'api/queries/cardsData.query';
import { QueryResponse as boardInitResponse } from 'api/queries/getBoardInitLite.query';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';

import { TrackedUntrackedAction } from 'components/common/TrackedUntrackedAction/trackedUntrackedAction';

import {
    IActiveTab,
    TabsSection,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/ProgramActivityCardModal.module.scss';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/ProgramActivityCardModal.types';
import { tabsArrData } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/ProgramActivityCardModal.utils';
import { CardContent } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/components/CardContent/CardContent';
import { CardHeader } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/components/CardHeader/CardHeader';
import { ProgramActivityCardStatusSelect } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/components/ProgramActivityCardStatusSelect/ProgramActivityCardStatusSelect';
import { SideMenu } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/components/SideMenu/SideMenu';

interface Props {
    data: CardResponse;
    activeTab: IActiveTab;
    setValue: UseFormSetValue<IFields>;
    control: Control<IFields, any, IFields>;
    setActiveTab: React.Dispatch<React.SetStateAction<IActiveTab>>;
    watch: UseFormWatch<IFields>;
    boardInit: boardInitResponse | undefined;
    errors: FieldErrors<IFields>;
    handleCardClose: () => void;
    register: UseFormRegister<IFields>;
    queryKeys: string[];
    isCardDirty: boolean;
}

export const ProgramActivityCardModalDesktop = ({
    data,
    activeTab,
    setValue,
    control,
    setActiveTab,
    watch,
    boardInit,
    errors,
    register,
    queryKeys,
}: Props) => {
    return (
        <>
            <SideMenu
                title={data.title}
                taskId={data.taskId}
                taskVersionHashCode={data.taskVersionHashCode}
                originalStatus={data.originalStatus}
                originalStartDate={data.originalStartDate}
                originalEndDate={data.originalEndDate}
                setValue={setValue}
                category={data.category.name}
                isInterimChanged={data.isInterimChanged}
            />

            <CardHeader control={control} />
            <div className={classes.tabsWithStatusWrapper}>
                <TabsSection tabs={tabsArrData} activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className={classes.starWrapper}>
                    <TrackedUntrackedAction
                        isTracked={data.isTracked}
                        taskVersionHashCode={data.taskVersionHashCode}
                        invalidateQueriesKey={['getCard', cardsDataQueryKey]}
                        dataTrackId={'card'}
                    />
                    <ProgramActivityCardStatusSelect
                        control={control}
                        category={watch('category')}
                        originalStatus={watch('originalStatus')}
                        isInterimChanged={data.isInterimChanged}
                    />
                </div>
            </div>

            <CardContent
                activeTab={activeTab}
                boardInit={boardInit}
                setValue={setValue}
                watch={watch}
                control={control}
                errors={errors}
                data={data}
                queryKeys={queryKeys}
                register={register}
            />
        </>
    );
};
